import { StatementCheckbox } from '@maia/ui';
import { ComponentProps } from 'react';
import { useFieldContext } from '../dynamic-form';

export function StatementCheckboxField(
  props: ComponentProps<typeof StatementCheckbox>,
) {
  const field = useFieldContext<boolean>();
  return (
    <StatementCheckbox {...props} onChange={field.handleChange} onBlur={field.handleBlur} />
  );
}
